export default __webpack_public_path__ + "static/media/stratingScreen.6edc5f37.png";